import {Component, Inject, Input, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import { AbstractTableComponent } from 'bloonde-ngx-template/src/tables/partials/abstract-table/abstract-table.component';
import { TableOptions } from 'bloonde-ngx-template/src/tables/models/table-options';
import { OfferCandidateListItem } from '../../../models/listings/offer_candidate_list_item';
import { Pagination } from 'bloonde-ngx-template/src/tables/models/pagination';
import { OfferCandidateTableFilter } from './offer-candidate-table-filter';
import { OfferCandidateTableOrder } from './offer-candidate-table-order';
import { OfferCandidateTableVisibility } from './offer-candidate-table-visibility';
import { DataHeader } from 'bloonde-ngx-template/src/tables/models/data-header';
import { OfferCandidateService } from '../../../services/offer-candidate.service';
import { ResponseHelper } from 'bloonde-ngx-template/src/responses/response.helper';
import { NavigationHelper } from 'bloonde-ngx-template/src/navigation/navigation.helper';
import { ListRequestData } from 'bloonde-ngx-template/src/api/tools/list-request-data';
import { TableComponent } from 'bloonde-ngx-template/src/tables/partials/table/table.component';
import { StatusFilterComponent } from '../../filters/status-filter/status-filter.component';
import {PositionFilterComponent} from '../../filters/position-filter/position-filter.component';
import {ExperienceFilterComponent} from '../../filters/experience-filter/experience-filter.component';
import {formatDate} from '@angular/common';
import {StateFilterComponent} from '../../filters/state-filter/state-filter.component';

@Component({
  selector: '[app-offers-candidates-table]',
  templateUrl: './offers-candidates-table.component.html',
  styleUrls: ['./offers-candidates-table.component.sass']
})
export class OffersCandidatesTableComponent extends AbstractTableComponent implements OnInit {

  @ViewChild(TableComponent) tableComponent;

  @Input() tableOptions: TableOptions;
  @Input() public candidate_id;
  @Input() public offer_id;

  public offersCandidates: OfferCandidateListItem[];
  public pagination: Pagination;

  public filter: OfferCandidateTableFilter = new OfferCandidateTableFilter();
  public order: OfferCandidateTableOrder = new OfferCandidateTableOrder();
  public visibility: OfferCandidateTableVisibility = new OfferCandidateTableVisibility();

  public dataHeader: DataHeader = {
    title: {
      isShow: true,
      label: 'Offer Candidate Management',
    },
    filters: {
      isShow: true,
      items: [
        {
          component: StatusFilterComponent,
          cols: 'col-3',
          inputs_and_outputs: [
            {attr: 'placeholder', value: 'Status', type: 'property'},
            {attr: 'type', value: 'offer_candidate', type: 'property'},
            {attr: 'modelChange', value: 'status_id', type: 'output'},
            {attr: 'model', value: this.filter.statusIdModelChange, type: 'input'}
          ]
        },
        {
          component: StateFilterComponent,
          cols: 'col-3',
          inputs_and_outputs: [
            {attr: 'placeholder', value: 'State', type: 'property'},
            {attr: 'modelChange', value: 'state_id', type: 'output'},
            {attr: 'model', value: this.filter.stateIdModelChange, type: 'input'}
          ]
        },
        {
          component: PositionFilterComponent,
          cols: 'col-3',
          inputs_and_outputs: [
            {attr: 'placeholder', value: 'Position', type: 'property'},
            {attr: 'modelChange', value: 'position', type: 'output'},
            {attr: 'model', value: this.filter.positionModelChange, type: 'input'}
          ]
        },
        {
          component: ExperienceFilterComponent,
          cols: 'col-3',
          inputs_and_outputs: [
            {attr: 'placeholder', value: 'Experience', type: 'property'},
            {attr: 'modelChange', value: 'experience', type: 'output'},
            {attr: 'model', value: this.filter.experienceModelChange, type: 'input'},
            {attr: 'disabled', value: this.filter.disabledModelChange, type: 'input'}
          ]
        },
      ]
    },
    btns: {
      isShow: true,
      float: 'right',
      items: [
        {
          isShow: false,
          value: 'Alta',
          icon: 'fas fa-plus',
          style: '',
          action: 'create'
        },
        {
          isShow: false,
          action: 'bulk-interviewing',
          value: 'Interviewing',
          text: 'Interviewing',
          icon: 'fas fa-users',
          style: 'btn btn-light',
        },
        {
          isShow: false,
          action: 'bulk-discard',
          value: 'Discard',
          text: 'Discard',
          icon: 'fas fa-times',
          style: 'btn btn-light',
        },
        {
          isShow: false,
          action: 'bulk-selected',
          value: 'Selected',
          text: 'Selected',
          icon: 'fas fa-check',
          style: 'btn btn-light',
        },
      ]
    },
    actions: [
      {
        action: 'edit',
        isShow: true,
        icon: 'fas fa-edit',
        title: 'Edit'
      },
      {
        action: 'interviewing',
        isShow: false,
        icon: 'fas fa-users',
        title: 'Interviewing'
      },
      {
        action: 'discard',
        isShow: false,
        icon: 'fas fa-times',
        title: 'Discard'
      },
      {
        action: 'selected',
        isShow: false,
        icon: 'fas fa-check',
        title: 'Selected'
      },
      {
        action: 'see',
        isShow: true,
        icon: 'fas fa-eye',
        title: 'See candidate'
      },
    ],
    style: ''
  };

  public isTable: boolean = true;

  constructor(
    private offerCandidateService: OfferCandidateService,
    private responseHelper: ResponseHelper,
    private navigationHelper: NavigationHelper,
    @Inject(LOCALE_ID) private locale: string
  ) {
    super();
  }

  ngOnInit() {
    if (this.offer_id) { // Estamos en el panel del evaluador viendo las candidaturas de una oferta
      this.visibility.candidatures = false;
    } else if (this.candidate_id) { // Estamos en el panel del evaluador viendo las candidaturas de un candidato (en su vista de edición)
      this.visibility.candidate_name = false;
    } else { // Estamos en el panel de un candidato viendo sus candidaturas
      this.visibility.candidate_name = false;
    }
    this.filter.candidate_id = this.candidate_id;
    if (!this.tableOptions) {
      this.tableOptions = new TableOptions('offer-candidate-management');
    }
    this.resetFiltersOrdersAndColumns();
    if (this.tableOptions.withPagination) {
      this.pagination = new Pagination();
      this.pagination.currentPage = 1;
      this.pagination.itemPerPage = this.tableOptions.paginationItemsPerPage;
    }
    if (this.tableOptions.autoload) {
      this.list();
    }
  }

  list(): void {
    if (this.candidate_id) {
      this.filter.candidate_id = this.candidate_id;
    }
    if (this.offer_id) {
      this.filter.offer_id = this.offer_id;
    }
    this.cleanSelected();
    this.saveFiltersAndOrders();
    const listRequestData = new ListRequestData(this.pagination ? this.pagination.currentPage : null, this.filter, this.order);
    this.offerCandidateService.list(listRequestData).subscribe(
      res => {
        this.offersCandidates = <OfferCandidateListItem[]> res['elements'];
        if (this.tableOptions.withPagination) {
          this.pagination.total = res['total'];
        }
        this.getHeader();
        this.getData();
      },
      error => {
        this.responseHelper.handleError(error);
      }
    );
  }

  defaultFilter(): any {
    return new OfferCandidateTableFilter();
  }
  defaultOrders(): any {
    return new OfferCandidateTableOrder();
  }
  defaultVisibility(): any {
    return new OfferCandidateTableVisibility();
  }
  getElements(): any {
    return this.offersCandidates;
  }
  getFilter(): any {
    return this.filter;
  }
  getOrder(): any {
    return this.order;
  }
  getVisibility(): any {
    return this.visibility;
  }
  setFilter(filter: any): void {
    this.filter.copy(filter);
  }
  setOrder(order: any): void {
    this.order = order;
  }
  setVisibility(visibility: any): void {
    if (this.offer_id) { // Estamos en el panel del evaluador viendo las candidaturas de una oferta
      visibility.candidatures = false;
    } else if (this.candidate_id) { // Estamos en el panel del evaluador viendo las candidaturas de un candidato (en su vista de edición)
      visibility.candidate_name = false;
    } else { // Estamos en el panel de un candidato viendo sus candidaturas
      visibility.candidate_name = false;
    }
    this.visibility = visibility;
  }
  getLocalStorageKey(): any {
    return this.tableOptions.localStorageKey;
  }
  getAllSelectorCheckbox(): any {
    if (this.tableComponent) {
      return this.tableComponent.getAllSelectorCheckbox();
    }
  }
  getSelectorCheckboxes(): any {
    return this.tableComponent.getSelectorCheckboxes();
  }
  hasActionColumn(): boolean {
    return this.tableOptions.hasActionColumn;
  }
  hasCheckboxColumn(): boolean {
    return this.tableOptions.hasCheckboxColumn;
  }
  changeFilter($event) {
    this.filter[$event['key']] = $event['value'];
    if (this.filter.position) {
      this.filter.disabledModelChange.emit(false);
    } else {
      this.filter.experienceModelChange.emit(null);
      this.filter.disabledModelChange.emit(true);
    }
    this.listWithTimeout();
  }
  enterSearch($event) {
    this.filter.search = $event.event.target.value;
    this.listWithTimeout();
  }
  clickHeaderBtn(e) {
    if ( e.action === 'create' ) {
      this.onCreate();
    } else {
      this.HandlerHeaderClickBtn.emit(e);
    }
  }
  constructBodyColumnsExceptions(key, value, isShow, isOrder, item): any {
    let objectData = null;
    let translate = false;
    if ( key === 'status_id') {
      value = 'offer_candidate_status_' + value;
      translate = true;
    }
    if ( key === 'candidate_name') {
      value = value + ' ' + item['candidate_surname'];
      translate = true;
    }
    if (key === 'registration_date') {
      value = this.transformDate(item[key]);
    }
    objectData = this.setData(key, isShow, isOrder, value, translate);
    return objectData;
  }

  transformDate(date: any, format: string = 'dd/MM/yyyy') {
    return formatDate(date, format, this.locale);
  }

  getDataActions(item: any): any {
    let actions = this.copyActionHeaders();
    for (let action of actions) {
      if (action.action == 'interviewing' && item.status_id == OfferCandidateService.WAITING_STATUS_ID) {
        action.isShow = true;
      } else if (action.action == 'interviewing' && item.status_id != OfferCandidateService.WAITING_STATUS_ID) {
        action.isShow = false;
      }
      if (action.action == 'selected' && item.status_id == OfferCandidateService.INTERVIEWING_STATUS_ID) {
        action.isShow = true;
      } else if (action.action == 'selected' && item.status_id != OfferCandidateService.INTERVIEWING_STATUS_ID) {
        action.isShow = false;
      }
      if (action.action == 'discard' && (item.status_id == OfferCandidateService.INTERVIEWING_STATUS_ID || item.status_id == OfferCandidateService.WAITING_STATUS_ID)) {
        action.isShow = true;
      } else if (action.action == 'discard' && !(item.status_id == OfferCandidateService.INTERVIEWING_STATUS_ID || item.status_id == OfferCandidateService.WAITING_STATUS_ID)) {
        action.isShow = false;
      }
    }
    return actions;
  }
  copyActionHeaders() {
    let result = [];
    for (let action of this.dataHeader.actions) {
      let auxAction = {};
      auxAction['action'] = action['action'];
      auxAction['isShow'] = action['isShow'];
      auxAction['icon'] = action['icon'];
      auxAction['title'] = action['title'];
      result.push(auxAction);
    }
    return result;
  }

  extendAddOrRemove() {
    if ( this.selected.length > 0 ) {
      for ( let x = 0; x < this.dataHeader.btns.items.length; x++ ) {
        if ( this.dataHeader.btns.items[x].action === 'bulk-interviewing' ) {
          this.dataHeader.btns.items[x].isShow = true;
        }
        if ( this.dataHeader.btns.items[x].action === 'bulk-selected' ) {
          this.dataHeader.btns.items[x].isShow = true;
        }
        if ( this.dataHeader.btns.items[x].action === 'bulk-discard' ) {
          this.dataHeader.btns.items[x].isShow = true;
        }
      }
    }
    if ( this.selected.length === 0 ) {
      for ( let x = 0; x < this.dataHeader.btns.items.length; x++ ) {
        if ( this.dataHeader.btns.items[x].action === 'bulk-interviewing' ) {
          this.dataHeader.btns.items[x].isShow = false;
        }
        if ( this.dataHeader.btns.items[x].action === 'bulk-selected' ) {
          this.dataHeader.btns.items[x].isShow = false;
        }
        if ( this.dataHeader.btns.items[x].action === 'bulk-discard' ) {
          this.dataHeader.btns.items[x].isShow = false;
        }
      }
    }
  }
}
